module.exports = __webpack_public_path__ + "static/media/straight-right-left.e13e6d41.svg";